module.exports = __webpack_public_path__ + "img/vQR_j.7101efc9.png";